module.exports = ".container {\n  width: 100%;\n  height: 100%;\n  overflow: auto;\n  background: #eee; }\n  .container .inner {\n    text-align: left;\n    padding: 20px; }\n  .actions {\n  text-align: center; }\n  .btnAdd {\n  position: fixed;\n  right: 50px;\n  bottom: 15px; }\n  .action_btn {\n  min-width: 36px;\n  padding: 0;\n  margin: 0;\n  color: #666; }\n  .add-client-btn {\n  position: absolute;\n  right: 25px;\n  bottom: 25px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/views/component-variants-view/component-variants-view.component.scss
// module id = ./src/app/components/views/component-variants-view/component-variants-view.component.scss
// module chunks = main